import { render } from "./singapore.vue?vue&type=template&id=7faf0258&scoped=true"
import script from "./singapore.vue?vue&type=script&lang=js"
export * from "./singapore.vue?vue&type=script&lang=js"

import "./singapore.vue?vue&type=style&index=0&id=7faf0258&lang=scss&scoped=true"
import "./singapore.vue?vue&type=style&index=1&id=7faf0258&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7faf0258"

export default script